import { CanDeactivateFn } from "@angular/router";
import { NutzerProfileComponent } from "../../page/nutzer-profile/nutzer-profile.component";

/**
 * Gaurd to check if a user has unhandled changes in the nutzer profile page. It will open a pop up dialog to confirm the leaving with changes at hand.
 * @param component the nutzerprofile page
 * @returns boolean if the user wants or is allowed to leave
 */
export const nutzerProfileCanDeactivateGuard: CanDeactivateFn<NutzerProfileComponent> = (component): Promise<boolean> => {
    if (component.canDeactivate) {
        return component.canDeactivate();
    }
    return Promise.resolve(true);
}